import cx from 'classnames';
import { useRouter } from 'next/router';
import { FormattedMessage as T } from 'react-intl';
import { useGlobalConfig } from '../../hooks/configContext';
import { Otovo$Locale } from '../../types/otovoweb';
import { Sanity$ProductPage } from '../../types/sanityTypes';
import { useProductPages } from '../Sanity/ProductPages/useProductPages';
import getSortedProductPageLinks from './getSortedProductPageLinks';
import m from './messages';
import useLocalizedPath from './useLocalizedPath';

type Props = {
  includeDomainInUrls: boolean;
};

type ProductPageLinks = [Sanity$ProductPage[], string];

function useProductPageLinks(includeDomainInUrls: boolean): ProductPageLinks {
  const locale = useRouter().locale as Otovo$Locale;
  const { STOREFRONT_URL, BU_CONFIG } = useGlobalConfig();
  const { isMultiLocaleBu } = BU_CONFIG;

  const productPages = useProductPages();
  const sortedProductPages = getSortedProductPageLinks(productPages || []);

  const localizedPath = useLocalizedPath('/products');

  const domain = includeDomainInUrls ? STOREFRONT_URL : '';

  let pathPrefix = `${domain}${localizedPath}`;

  if (isMultiLocaleBu) {
    pathPrefix = `${domain}/${locale}${localizedPath}`;
  }

  return [sortedProductPages, pathPrefix];
}

export function ProductPageMenuLinks({ includeDomainInUrls = false }: Props) {
  const [productPages, pathPrefix] = useProductPageLinks(includeDomainInUrls);

  return (
    <>
      {!!productPages?.length && (
        <div>
          <T {...m.productPageBurgerMenu} />
          <ul>
            {productPages.map((page) => (
              <li key={page._id}>
                <a
                  href={`${pathPrefix}/${page.slug}/`}
                  className="block py-2 pl-6 text-lg hover:underline hover:underline-offset-4"
                >
                  {page.burgerMenuTitle}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
}

export function ProductPageNavLinks({ includeDomainInUrls = false }: Props) {
  const { asPath } = useRouter();
  const [productPages, pathPrefix] = useProductPageLinks(includeDomainInUrls);

  return (
    <>
      {(productPages || []).map((page) => (
        <a
          key={page._id}
          href={`${pathPrefix}/${page.slug}/`}
          className={cx(
            'rounded-sm px-3 py-2 text-sm text-grey-90 hover:bg-grey-5 lg:text-base',
            asPath.indexOf(page.slug) > 0 ? 'font-semibold' : 'font-normal',
          )}
        >
          {page.burgerMenuTitle}
        </a>
      ))}
    </>
  );
}
